export const SET_TOPBAR_BOOKING_LINK = 'SET_TOPBAR_BOOKING_LINK';
export const CLEAR_TOPBAR_BOOKING_LINK = 'CLEAR_TOPBAR_BOOKING_LINK';

// The startup page sets the founder's booking link while it is open so the
// topbar can show the "Book a call" pill, and clears it when leaving.
export function setTopbarBookingLink(bookingLink) {
  return {
    type: SET_TOPBAR_BOOKING_LINK,
    bookingLink,
  };
}

export function clearTopbarBookingLink() {
  return {
    type: CLEAR_TOPBAR_BOOKING_LINK,
  };
}
